//export const MEDIA_URL = 'http://localhost:3000/media/';
//export const MEDIA_URL = 'https://dev-api.blossomsfood.com.sg/media/';
export const MEDIA_URL = 'https://inventory.blossomsfood.com.sg/assets/uploads/'; // LIVE URL
//export const MEDIA_URL = 'https://dev-admin.blossomsfood.com.sg/assets/uploads/'; // dev URL
export const ANNOUNCEMENT_IMAGE_FOLDER = 'announcement/';
export const WHATSUP_IMAGE_FOLDER = 'whatsup/';
export const TOKEN_KEY = 'token';
export const CUSTOMER_DATA_KEY = 'customer';
export const REDIRECT_PAGE_AFTER_LOGIN = '/landing';
export const CONTINUE_ADDING = '/menu';
export const PENDING_ORDERS = '/bill';
export const CART = '/cart';
export const REDIRECT_PAGE_NOT_LOGGED_IN = '/';
export const IMAGEURL = "https://inventory.blossomsfood.com.sg/assets/uploads/"; // LIVE URL
//export const IMAGEURL = "https://dev-admin.blossomsfood.com.sg/assets/uploads/"; // dev URL
export const PRODUCTS_LIMIT = 24;
export const CATEGORIES_LIMIT = 28;
export const FAVOURITES_LIMIT = 18;
export const PENDING_ORDERS_LIMIT = 100;
export const ORDERS_LIMIT = 100;
export const CART_ITEMS_KEY = 'cart_items';
export const CURRENCY_SYMBOL = '$';
export const DISTRICT_MANAGER_ROLE = 3;
export const REDIRECT_ORDER_APPROVAL_PAGE = '/district-manager/pending-orders';
export const RESTRICTED_MENUS_FOR_DM = [
    "/menu",
    "/bill",
    "/cart",
    "/menu-details",
    "/hqdashboard",
    "/favourites",
    "/hqreport",
    "/hqproductreport"
  ];
  export const RESTRICTED_MENUS_FOR_BRANCH = [
    "/hqreport",
    "/hqproductreport"
  ];
export const HQ_CUSTOMER_ROLE = 1;
export const BRANCH_CUSTOMER_ROLE = 2;
  